// import {QuestionModelV3} from '@albert-io/models';
import React from 'react';
import {
  QuestionComponent,
  QuestionComponentProps
} from '../../shared/QuestionComponent/QuestionComponent.react';
import FitbItemBankInputArea from './InputArea.react';

const FitbItemBankComponent = (props: QuestionComponentProps) => {
  // const {activeQuestion} = props;
  return (
    <QuestionComponent
      {...props}
      // customExplanation={<PassageCorrectionExplanation question={activeQuestion} />}
      ActiveQuestionInputArea={FitbItemBankInputArea}
    />
  );
};

type FitbCommonBankQuestionTypeProps = Omit<QuestionComponentProps, 'questionState'>;

const FillInTheBlankQuestionBank = {
  PreGuess: (props: FitbCommonBankQuestionTypeProps) => (
    <FitbItemBankComponent {...props} questionState='PreGuess' />
  ),
  PostGuess: (props: FitbCommonBankQuestionTypeProps) => (
    <FitbItemBankComponent {...props} questionState='PostGuess' />
  ),
  Dennis: (props: FitbCommonBankQuestionTypeProps) => (
    <FitbItemBankComponent {...props} questionState='Dennis' />
  )
};

export {FillInTheBlankQuestionBank};
